import React, { PureComponent } from 'react'
import NavBar from "./navigation/nav-bar"
import { Link } from 'react-router-dom'
import Button from './ui/button'
import NavStatistics from './navigation/nav-statistics'
import NavMainAftergameLinks from './navigation/nav-main-aftergame-links'
import StatisticsPageHero from './ui/statistics-page-hero'
import ParameterFilter from './ui/parameter-filter'
import ThemeStatCard from './ui/theme-stat-card'
import SortingWidget from './ui/sorting-widget'
import { sortingService } from '../utilities/sortingService'
import { Survey } from '../utilities/Survey'
import { formPagePath } from '../utilities/route'
import { mergeWithStatistics, likertResponseToPercentage } from '../utilities/statistics'

class FinishPage extends PureComponent {

  constructor(props) {
    super(props);
    const _surveyBeingEdited = sessionStorage.getItem("surveyBeingEdited") || false
    this.state = {
      surveyBeingEdited: !!(_surveyBeingEdited && _surveyBeingEdited === "true")
    };
  }

  t = (phrase) => {
    const { useTranslate } = this.props;

    return useTranslate(`data_vault.${phrase}`);
  }

  handleFiltersChange = value => {
    this.props.onSetFilters(value);
  }

  render() {
    const {
      surveyStatistics,
      respondentParameters,
      match: {
        params: { surveyId, languageCode },
      },
      questionnaire,
      questionnaire: {
        canViewAfterGame,
        logo,
        isFinished,
        canAnswer,
        isAfterGameGuest,
        isDialogueActive,
        areProgressReportsActive,
      },
      useTranslate,
      sortingType,
      sortAscending,
      filters,
      improvementProject
    } = this.props;

    const toStatistics = formPagePath(languageCode, surveyId, 'finish', 'themes');
    const toEditAnswers = formPagePath(languageCode, surveyId);

    const title = (!canViewAfterGame && !isAfterGameGuest)
      ? useTranslate("survey_finished.your_statistics_page_title")
      : useTranslate("data_vault.statistics_page_title");

    const startEditingSurvey = () => {
      sessionStorage.setItem("surveyBeingEdited", "true");
      this.setState({surveyBeingEdited: true});
    }

    let sortedThemes
    const notEnoughRespondents = surveyStatistics.__typename === 'NotEnoughRespondentsError'
    if (!notEnoughRespondents) {
      const survey = new Survey(questionnaire.catalysts, respondentParameters)
      const sortingFunction = sortingService.getSortingFunction(sortingType);
      sortedThemes = mergeWithStatistics(survey.getThemes(), surveyStatistics.themes).map((theme) => {
        const surveyThemeIndex = survey.getSurveyThemeIndex(theme.id)
        return {
          id: theme.id,
          title: theme.title,
          result: likertResponseToPercentage(theme.statistics.aggregatedResponse),
          rate: theme.statistics.aggregatedImportance,
          surveyThemeIndex,
          drivers: mergeWithStatistics(survey.getDrivers(), surveyStatistics.drivers)
            .filter(d => survey.getThemeIdByDriverId(d.id) === theme.id)
            .map(driver => {
              return {
                title: driver.title,
                result: likertResponseToPercentage(driver.statistics.aggregatedResponse),
                rate: driver.statistics.aggregatedImportance,
                surveyThemeIndex
              }
            })
        }
      }).sort(sortingFunction(sortAscending ? sortAscending : false));
    }

    return (
      <section className="finish-page">
        <StatisticsPageHero>
          <div className="aftergame-page-container">
            <NavBar
              to={isFinished && !canViewAfterGame && toStatistics}
              inverse={true}
              afterGame
              logo={logo}
              canViewAfterGame={canViewAfterGame}
              isAfterGameGuest={isAfterGameGuest}
            >
              {(canViewAfterGame || isAfterGameGuest) &&
                <NavMainAftergameLinks
                  activePage={"statistics"}
                  languageCode={languageCode}
                  surveyId={surveyId}
                  useTranslate={useTranslate}
                  isDialogueActive={isDialogueActive}
                  showProgressReports={areProgressReportsActive}
                  improvementProject={improvementProject}
                />
              }
            </NavBar>
          </div>
          <div className="aftergame-page-container">
            <div className="finish-page__intro">
              <h1>{title}</h1>
              { (!canViewAfterGame && !isAfterGameGuest) ?
                <div className="stats-description">
                  <p>{useTranslate("survey_finished.your_statistics_page_description")}</p>
                  { (isFinished && !canViewAfterGame && canAnswer) &&
                    <div>
                      <Button
                        as={Link}
                        to={toEditAnswers}
                        onClick={() => startEditingSurvey()}
                        size={"md"}
                      >
                        {this.t("edit_answers_button")}
                      </Button>
                    </div>
                  }
                </div>
                :
                <div className="stats-description">
                  <p>{useTranslate("data_vault.statistics_page_description")}</p>
                </div>
              }
              <div className="finish-page__intro__nav-holder">
                <NavStatistics
                  activePage={"themes"}
                  languageCode={languageCode}
                  surveyId={surveyId}
                  useTranslate={useTranslate}
                  questionnaire={questionnaire}
                />
              </div>
            </div>
          </div>
        </StatisticsPageHero>

        <div className="aftergame-page-container statistics-page-content finish-page__stats">
          <div className="finish-page__filters">
            {((canViewAfterGame || isAfterGameGuest) && respondentParameters.length > 0)  && (
              <ParameterFilter
                filters={filters}
                handleFiltersChange={this.handleFiltersChange}
                respondentParameters={respondentParameters}
                isAfterGameGuest={isAfterGameGuest}
                useTranslate={useTranslate}
              />
            )}
            <SortingWidget useTranslate={useTranslate} />
          </div>
          <div className="catalyst-cards mb-5">
            {!notEnoughRespondents ?
              sortedThemes.map((theme, index) => {
                return (
                  <ThemeStatCard
                    key={index}
                    theme={theme}
                    filters={filters}
                    respondentParameters={respondentParameters}
                    surveyId={surveyId}
                    languageCode={languageCode}
                    canViewAfterGame={canViewAfterGame}
                    isAfterGameGuest={isAfterGameGuest}
                    useTranslate={useTranslate}
                  />
                )
              })
              :
              <p>{useTranslate("data_vault.no_results_for_parameter")}</p>
            }
            {}
          </div>
        </div>
      </section>
    );
  }
}

export default FinishPage;



// WEBPACK FOOTER //
// ./src/components/statistics-page-themes.js